import { Box, Button, Link, Typography } from "@mui/material";
import { FC } from "react";

import __ from "web/Layout/Translations";

import setBenefitGroupTypeParam from "web/utils/page/product/subscription/setBenefitGroupTypeParam";

import urls from "web/constants/urls";

import { ChoiceButtonType } from "web/types/Subscription";

interface ISubscriptionLinkProps {
  type: ChoiceButtonType;
  disabled?: boolean;
  group?: number;
  isBenefitListInThisGroupEmpty: boolean;
}

const SubscriptionLinkMUI: FC<ISubscriptionLinkProps> = ({
  type,
  disabled = false,
  group = 1,
  isBenefitListInThisGroupEmpty,
}) => {
  const url =
    type === ChoiceButtonType.CHANGE_SUBSCRIPTIONS
      ? `${urls.checkoutSubscriptionConfiguration}${setBenefitGroupTypeParam(
          group
        )}`
      : urls.customerSubscriptions;
  const label =
    type === ChoiceButtonType.CHANGE_SUBSCRIPTIONS
      ? __("Zarządzaj abonamentami")
      : __("Moje abonamenty");

  return (
    <Box>
      <Box>
        <Button
          component={Link}
          variant="contained"
          color="primary"
          size="large"
          data-t1="subscriptionSelectionLink"
          data-t2={`group${group}`}
          sx={{
            width: { xs: "311px", lg: "284px" },
            m: "4px",
            "&:hover": {
              color: "#FFF",
            },
          }}
          disabled={disabled}
          href={!disabled ? url : undefined}
        >
          {label}
        </Button>
        {disabled && (
          <Typography
            variant="body2"
            sx={{
              textAlign: isBenefitListInThisGroupEmpty ? "center" : "right",
              mr: "5px",
            }}
          >
            {__("Minął termin wyboru abonamentów")}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default SubscriptionLinkMUI;
